export default __webpack_public_path__ + "static/media/defaultImage.7d0823ce.jpg";